import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { EntityListModule } from 'common/entityList'
import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'

import { VolumeIconComponent } from './components/volumeIcon.component'
import { WorkspaceIconComponent } from './components/workspaceIcon.component'
import { NfsPermissionsEditor } from './components/nfsPermissionsEditor.component'
import { NfsPermissionsEditorModalComponent } from './components/nfsPermissionsEditorModal.component'
import { FormsModule } from '@angular/forms'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    EntityListModule,
    LocaleModule.forChild(),
    FormsModule,
  ],
  declarations: [
    VolumeIconComponent,
    WorkspaceIconComponent,
    NfsPermissionsEditor,
    NfsPermissionsEditorModalComponent,
  ],
  exports: [
    VolumeIconComponent,
    WorkspaceIconComponent,
    NfsPermissionsEditorModalComponent,
  ],
})
export class StorageModule { }

export { StorageConstants } from './constants'
export { FilesystemService } from './services/filesystem.service'
